<div class="field-dialog__content__scroll p-24 tab-links">
  <div class="tab-links__info">
    <div class="tab-links__info-new">
      {{ 'MAINTENANCES.CREATE_DIALOG.TAB_LINKS.FEATURE.NEW' | translate }}
    </div>
    <img src="assets/images/icons/ic_creation.svg" alt="icon" />
    <p class="tab-links__info-text">
      <span>{{ 'MAINTENANCES.CREATE_DIALOG.TAB_LINKS.FEATURE.TITLE' | translate }}&nbsp;</span>
      <span (click)="openDemonstrationVideoDialog()" class="tab-links__info-text--link">
        {{ 'MAINTENANCES.CREATE_DIALOG.TAB_LINKS.FEATURE.CLICK_HERE' | translate }}&nbsp;
      </span>
      <span>{{ 'MAINTENANCES.CREATE_DIALOG.TAB_LINKS.FEATURE.TO_KNOW_MORE' | translate }}</span>
    </p>
  </div>

  <div class="tab-links__info">
    <mat-icon class="tab-links__info-icon">info</mat-icon>
    <p class="tab-links__info-text">
      <span>{{ 'MAINTENANCES.CREATE_DIALOG.TAB_LINKS.INFO' | translate }}&nbsp;</span>
    </p>
  </div>

  <div>
    <fc-outlined-input
      [prefixIcon]="'search'"
      [control]="searchControl"
      [required]="false"
      [label]="'MAINTENANCES.CREATE_DIALOG.TAB_LINKS.INPUT_PLACEHOLDER' | translate"
    ></fc-outlined-input>
  </div>

  <div *ngIf="!hasLinkedItems" class="tab-links__empty">
    <p class="tab-links__empty-text">
      {{ 'MAINTENANCES.NO_ASSETS_LINKED' | translate }}
    </p>
  </div>

  <div *ngIf="hasLinkedItems" class="tab-links__linked">
    <div class="tab-links__linked__header">
      <p class="tab-links__linked__header-title">
        {{ 'MAINTENANCES.CREATE_DIALOG.TAB_LINKS.LINKED.TITLE' | translate }}
      </p>
    </div>
    <div class="tab-links__linked__tree">
      <div class="tab-links__linked__tree__node" *ngFor="let sector of locationLinks">
        <fc-tree-view [item]="sector"></fc-tree-view>
      </div>

      <div class="tab-links__linked__tree__node" *ngFor="let equipment of unlinkedEquipments">
        <fc-tree-view [item]="equipment"></fc-tree-view>
      </div>
    </div>
  </div>
</div>
